export const PAYMENT_METHOD = [
  { value: 'SERVICE_FEE', label: 'serviceFee' },
  { value: 'FIXED_FEE', label: 'fixedFee' },
  { value: 'EXTEND_FEE', label: 'extendFee' },
  { value: 'DRG', label: 'drg' },
];
